module.exports = __webpack_public_path__ + "static/testimonial-dave-hackshaw-55b46cf71f4b2e5cbf961abfc203e80d.jpg";